import { call, put, takeLatest } from "redux-saga/effects";
import { actions } from "./slice";
import * as API from "../../../../services/apis";

function* handleExportReport({ payload }) {
  const { filters, reportType, onSuccess, onFailure } = payload;
  try {
    const res = yield call(API.exportReport, { filters, reportType });
    const apiData = res?.data?.data;
    const apiMessage = res?.data?.message || "Report generation started successfully!";  
    yield put(actions.exportReportSuccess({ data: apiData, message: apiMessage }));  
    if (onSuccess) onSuccess(apiData, apiMessage);
  } catch (err) {
    const message =
      err?.response?.data?.message || err?.message || "Something went wrong";
      const userMessage = "Report generation failed";
    yield put(actions.exportReportFailure(message));
    if (onFailure) onFailure(userMessage);
  }
}
export function* reportExportSaga() {
  yield takeLatest(actions.exportReport.type, handleExportReport);
}